<template>
    <div class="header">
        <div class="Loading__bar___21yOt"
             style="background: rgb(33, 186, 69); width: 0%;height:2px;transition: width .35s;position: fixed;top:0">
        </div>
        <el-row>
            <el-col :span="15">
                <div class="logo">
                    <a href="https://www.ishouping.com"><span style="color: #fff">首屏好商贸</span></a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<span>客户管理中心</span>
                </div>
            </el-col>

            <el-col :span="6" class="text_right">
                <div>
                    <div class="backSuper school-info first_school">
                       <img src="../../../assets/img/user.png">
                        <span></span>
                    </div>
                    &nbsp;
                    <div class="backSuper school-info ">
                        <span></span>
                    </div>
                    &nbsp;
                    <div class="backSuper school-info ">
                        <span><a style="color: white;" :href="'https://www.ishouping.com/qiye/'+b_id" target="_blank">{{b_name}}</a></span>
                    </div>
                </div>
            </el-col>
            <el-col :span="2">

                <div class="user-info">
                    <b class="fgx">丨</b>
                    <div
                            class="el-dropdown-link"
                            @click="handleCommand"
                    >
                        <div class="navbar-right"></div>
                        <span class="tc">退出</span>
                    </div>

                    <!-- <el-dropdown-menu class="exit" slot="dropdown">
                          <div></div>
                          <el-dropdown-item command="loginout">退出</el-dropdown-item>
                        </el-dropdown-menu> -->
                </div>
            </el-col>

        </el-row>
    </div>
</template>

<script>
    import {mapMutations} from "vuex";

    export default {
        data() {
            return {};
        },
        computed: {
            b_name() {
                let myUsername = localStorage.getItem("org_b_name"); // 对象  没有是为null
                return myUsername !== null ? myUsername : '';
            },
            b_id() {
                let b_id = localStorage.getItem("org_b_id"); // 对象  没有是为null
                return b_id !== null ? b_id : '';
            },
        },
        mounted() {
            document.title = '商家后台-首屏好商贸'
        },
        methods: {
            handleCommand() {
                localStorage.removeItem("org_b_name");
                this.$ajax.get("/admin/Login/logout");
                this.$router.push("/");
            },
            ...mapMutations("navTabs", [
                // 下拉框选择所有已打开的标签
                "freshTabFunc"
            ]),
            ...mapMutations("navTabs", [
                // 下拉框选择所有已打开的标签
                "closeAllTabFunc"
            ])
        }
    };
</script>
<style>
    .navbar-right {
        width: 20px;
        height: 20px;
        margin: 4px 0 0 8px;
        vertical-align: middle;
        background: url(../../../assets/img/tc.png) no-repeat center center;
    }
</style>


// WEBPACK FOOTER //
// src/views/admin/home/Header.vue